import React from 'react'
import { useDrop } from 'react-dnd'

import * as ItemTypes from '@disco/constants/ItemTypes'

import { dndConnectRef } from 'utils/dnd-connect-ref'

type Props = {
  sidebarOpen: boolean
  toggleSidebar: () => void
  children: React.ReactNode
}

export default function SidebarDropWrapper({
  sidebarOpen,
  toggleSidebar,
  children,
}: Props) {
  const [, dropRef] = useDrop(
    () => ({
      accept: [ItemTypes.TRACK, ItemTypes.PLAYLIST, ItemTypes.GROUP],
      canDrop: () => false,
      hover: () => {
        if (!sidebarOpen) {
          toggleSidebar()
        }
      },
    }),
    [sidebarOpen, toggleSidebar],
  )

  return <div ref={dndConnectRef(dropRef)}>{children}</div>
}
